"use client";

import { useEffect } from "react";

/**
 * Registers the service worker required for PWA installability.
 * Renders nothing — mount once in the root layout.
 */
export function ServiceWorkerRegistrar() {
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.register("/sw.js");
    }
  }, []);

  return null;
}
